module.exports = __webpack_public_path__ + "img/financiar.4e832e85.png";